"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;
var React = _interopRequireWildcard(require("react"));
var _hooks = require("./hooks");
var _StaticTable = require("./StaticTable");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// type ClassNames = $ReadOnly<{wrapper?: string}>;

/**
 * Table
 * @param {React.ComponentType} Row - React.ComponentType<{data: Data, extras?: Extras, sortedKeys?: string[]}>
 * @param {string} className - string
 *
 **/

/**
 * Table
 * @param {React.ComponentType} Row - React.ComponentType<{data: Data, extras?: Extras, sortedKeys?: string[]}>
 * @param {string} className - string
 *
 */
function Table(props) {
  const {
    entries,
    sortable = true,
    defaultSortKey,
    defaultSortDirection = 'original',
    onSort,
    enableInternalSorting,
    idName = 'id',
    virtualizationOptions,
    testId
  } = props;

  /**
   *
   */

  const {
    sortedEntries,
    sortedKeys,
    ...sortableProps
  } = (0, _hooks.useSortableEntries)(entries, idName, {
    defaultSortKey,
    defaultSortDirection,
    onSort,
    enableInternalSorting
  });

  // Need to consider virtualization only if entries are more than 0 and virtualizationOptions are passed
  const virtualized = !!(virtualizationOptions && virtualizationOptions.rowsCount > 0 && entries.length > 0);
  return virtualized ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_StaticTable.StaticTableVirtualized, {
    ...props,
    ...sortableProps,
    sortable: sortable,
    entries: sortedEntries,
    rowKeys: sortedKeys,
    testId: testId
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_StaticTable.StaticTable, {
    ...props,
    ...sortableProps,
    sortable: sortable,
    entries: sortedEntries,
    rowKeys: sortedKeys,
    testId: testId
  });
}